// import the library
import { library } from '@fortawesome/fontawesome-svg-core';

// import your icons
import { faCircleNotch } from '@fortawesome/free-solid-svg-icons';

library.add(
    faCircleNotch,
  // more icons go here
);